import SuggestionBuilder from '@/services/listingDataService/builders/suggestion'
import type { SuggestionApi, SuggestionClient } from '@/services/listingDataService/types/suggestion'

export default class SuggestionCollectionBuilder {
  static map (data: SuggestionApi.Suggestion | SuggestionApi.Suggestion[]): SuggestionClient.Suggestion | SuggestionClient.Suggestion[] {
    if (Array.isArray(data)) {
      const suggestions = data.map(item => SuggestionBuilder.build(item))

      const resultsArray: SuggestionClient.Suggestion[] = []
      const seenPlaceNames = new Set<string>()

      for (let i = 0, len = suggestions.length; i < len; i++) {
        const item = suggestions[i]
        const placeName = item.location.placeName
        if (!seenPlaceNames.has(placeName)) {
          resultsArray.push(item)
          seenPlaceNames.add(placeName)
        }
      }

      return resultsArray
    } else {
      return SuggestionBuilder.build(data)
    }
  }
}
